import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, Container } from 'reactstrap';
import { AvForm, AvGroup, AvInput, AvFeedback, AvField } from 'availity-reactstrap-validation';
import MaterialIcon from 'material-icons-react';
import i18n from '../../i18next';

import { loadManager, saveManager, clearManager, dispatchErrorMessage } from '../../actions/index';
import { localizeCountryNames } from '../../utils/CommonUtils';
import { countryList, CHAIN_MANAGER } from '../../utils/Constants';

const INITIAL_STATE = {
    id: -1,
    name: '',
    phone: '',
    email: '',
    password: '',
    repeatPassword: '',
    countryCode: '',
    language: 'en',
    role: 'RESTAURANT_MANAGER',
    stateAlreadyCopiedFromProps: false,
    firstStepPassed: false,
    saveManagerStarted: false
};

class ManagerScreen extends Component {
    constructor(props) {
        super(props);

        this.state = INITIAL_STATE;
        this.state.role = this.props.role;

        this.toggle = this.toggle.bind(this);
        this.resetState = this.resetState.bind(this);
        this.changeState = this.changeState.bind(this);
        this.loadManager = this.loadManager.bind(this);
        this.saveManager = this.saveManager.bind(this);
        this.assignManager = this.assignManager.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (!this.state.firstStepPassed && (prevProps.manager !== this.props.manager && this.props.manager.id !== -1)) {
            this.setState({
                ...this.state,
                firstStepPassed: true
            })
        }
    }

    resetState() {
        this.props.clearManager();
        this.setState(INITIAL_STATE);
    }

    changeState({ target }) {
        this.setState({ ...this.state, [target.name]: target.value });
    }

    loadManager() {
        let regex = /[A-Za-z]/g;
        let isValidPhoneNumber = this.state.phone.match(regex);
        const regexNumbers = /[0-9]/g;
        let newPhone = [];
        this.state.phone.match(regexNumbers).map(singleNumber => {
            newPhone.push(singleNumber);
        });

        if (newPhone > 17) {
            return this.props.dispatchErrorMessage(i18n.t('common:phoneValidation.phoneTooLong'));
        } else if (isValidPhoneNumber !== null) {
            return this.props.dispatchErrorMessage(i18n.t('common:phoneValidation.invalidPhone'));
        } else {
            this.props.loadManager(this.state.phone, this.state.email);
        }
    }

    saveManager() {
        let regex = /[A-Za-z]/g;
        let isValidPhoneNumber = this.state.phone.match(regex);
        const regexNumbers = /[0-9]/g;
        let newPhone = [];
        this.state.phone.match(regexNumbers).map(singleNumber => {
            newPhone.push(singleNumber);
        });

        if (newPhone > 17) {
            return this.props.dispatchErrorMessage(i18n.t('common:phoneValidation.phoneTooLong'));
        }

        if (isValidPhoneNumber !== null) {
            return this.props.dispatchErrorMessage(i18n.t('common:phoneValidation.invalidPhone'));
        }
        const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();

        // Parse number with country code and keep raw input.
        const number = phoneUtil.parseAndKeepRawInput(this.state.phone, this.state.countryCode);
        let validNumber = phoneUtil.isValidNumberForRegion(number, String(this.state.countryCode));

        if (!validNumber) {
            return this.props.dispatchErrorMessage(i18n.t('common:phoneValidation.phoneMatchFailure'));
        }

        this.setState({ ...this.state, saveManagerStarted: true });
        this.props.saveManager(this.state);
    }

    assignManager() {
        this.props.onAssign({
            id: this.state.id,
            name: this.state.name,
            phone: this.state.phone,
            email: this.state.email
        });
        this.resetState();
    }

    toggle() {
        const screenName = this.props.role === CHAIN_MANAGER ? 'managerScreen' : 'adminScreen';
        this.props.onToggle(screenName);
        this.resetState();
    }

    copyStateFromProps() {
        if (this.props.manager !== undefined && this.props.manager !== null &&
            this.props.manager.id !== undefined && this.props.manager.id !== -1 &&
            (!this.state.stateAlreadyCopiedFromProps || this.props.manager.id !== this.state.id)) {

            this.setState({
                id: this.props.manager.id,
                name: this.props.manager.name,
                phone: this.props.manager.phone,
                email: this.props.manager.email,
                language: this.props.manager.language,
                countryCode: this.props.manager.countryCode,
                stateAlreadyCopiedFromProps: true
            });
        }
    }

    renderFindManagerForm() {
        const { managerModalContainer } = styles;

        return (
            <AvForm className="modalForm" onValidSubmit={this.loadManager}>
                <ModalHeader className="modalHeader" toggle={this.toggle}>{this.props.title}</ModalHeader>
                <ModalBody>
                    <Container style={managerModalContainer}>
                        <AvGroup>
                            <AvField name="phone" label={i18n.t('common:form.phone')} type="phone"
                                value={this.state.phone}
                                onChange={this.changeState}
                                required
                                errorMessage={i18n.t('common:validations.errorMsg')}
                            />
                        </AvGroup>
                        <AvGroup>
                            <AvField type="email" name="email" label={i18n.t('common:form.email')}
                                value={this.state.email}
                                onChange={this.changeState}
                                required
                                errorMessage={i18n.t('common:validations.errorMsg')}
                            // validate={{
                            //     pattern: {
                            //         value: '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$',
                            //         errorMessage: i18n.t('common:validations.errorMsgEmail')
                            //     }
                            // }}
                            />
                            <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                        </AvGroup>
                    </Container>
                </ModalBody>
                <ModalFooter>
                    <Button outline color="primary" >{i18n.t('common:buttons.next')} <MaterialIcon icon="navigate_next" color="#0288D1" size={18} /></Button>
                </ModalFooter>
            </AvForm>
        );
    }

    renderCreateManagerForm() {

        const { warningColor, spaceBetween, managerModalContainer } = styles;

        return (
            <AvForm onValidSubmit={this.saveManager} className="modalForm">
                <ModalHeader className="modalHeader" toggle={this.toggle}>{this.props.title}</ModalHeader>
                <ModalBody>
                    <Container style={managerModalContainer}>
                        <p style={warningColor}>
                            {i18n.t('screens:managerScreen.warningOne')}
                            <p>{i18n.t('screens:managerScreen.warningTwo')}</p>
                        </p>
                        <AvGroup>
                            <Label for="name">{i18n.t('common:form.name')}</Label>
                            <AvInput
                                type="name" name="name" id="name"
                                value={this.state.name}
                                onChange={this.changeState}
                                required />
                            <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                        </AvGroup>
                        <AvGroup>
                            <AvField name="phone" label={i18n.t('common:form.phone')} type="phone"
                                value={this.state.phone}
                                onChange={this.changeState}
                                required
                                errorMessage={i18n.t('common:validations.errorMsg')}
                            />
                        </AvGroup>
                        <AvGroup>
                            <AvField type="email" name="email" label={i18n.t('common:form.email')}
                                value={this.state.email}
                                onChange={this.changeState}
                                required
                                errorMessage={i18n.t('common:validations.errorMsg')}
                            // validate={{
                            //     pattern: {
                            //         value: '[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$',
                            //         errorMessage: i18n.t('common:validations.errorMsgEmail')
                            //     }
                            // }}
                            />
                            <AvFeedback>{i18n.t('common:validations.errorMsg')}</AvFeedback>
                        </AvGroup>
                        <AvGroup>
                            <AvField
                                type="password" name="password" label={i18n.t('common:form.password')} minLength={6}
                                value={this.state.password}
                                onChange={this.changeState}
                                required
                                validate={{
                                    minLength: {
                                        value: 6,
                                        errorMessage: i18n.t('common:validations.passLength')
                                    }
                                }} />
                        </AvGroup>
                        <AvGroup>
                            <AvField
                                type="password" name="repeatPassword" label={i18n.t('common:form.repeatPass')}
                                value={this.state.repeatPassword}
                                onChange={this.changeState}
                                required
                                errorMessage={i18n.t('common:validations.errorMsg')}
                                validate={{
                                    match: {
                                        value: 'password',
                                        errorMessage: i18n.t('common:validations.matchPasswords')
                                    }
                                }} />
                        </AvGroup>
                        <AvGroup>
                            <AvField type="select" name="countryCode" id="country" placeholder={i18n.t('screens:restaurantsScreen.country')} label={i18n.t('screens:restaurantsScreen.country')}
                                value={this.state.countryCode}
                                errorMessage={i18n.t('common:validations.chooseCountry')}
                                required
                                onChange={this.changeState}
                            >
                                <option value="">{i18n.t('screens:generalScreen.chooseOption')}</option>
                                {this.renderCountryOptions()}
                            </AvField>
                        </AvGroup>
                        <AvGroup>
                            <AvField type="select" name="language" id="language" placeholder={i18n.t('common:form.lang')} label={i18n.t('common:form.lang')}
                                value={this.state.language}
                                errorMessage={i18n.t('common:validations.chooseLanguage')}
                                required
                            >
                                <option value="">{i18n.t('screens:generalScreen.chooseOption')}</option>
                                <option value="en">{i18n.t('common:languages.english')}</option>
                            </AvField>
                        </AvGroup>
                    </Container>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" ><MaterialIcon icon="check" color="#fff" size={20} /><span style={spaceBetween}>{i18n.t('screens:managerScreen.createAcc')}</span></Button>
                </ModalFooter>
            </AvForm>
        );
    }

    renderCountryOptions() {
        return countryList.map((country, i) => {
            return <option key={i} value={country}>{localizeCountryNames(country)}</option>
        });
    }

    renderAssignMessage(role) {
        switch (role) {
            case 'CHAIN_ADMIN':
                return i18n.t('screens:managerScreen.assignAdminMsg');
            case 'CHAIN_MANAGER':
                return i18n.t('screens:managerScreen.assignManagerMsg');
            case 'RESTAURANT_MANAGER':
                return i18n.t('screens:managerScreen.assignUserMsg');
            default:
                return '';
        }
    }

    renderAssignManagerForm() {

        const { modalBodyText, managerModalContainer } = styles;

        return (
            <div>
                <ModalHeader className="modalHeader" toggle={this.toggle}>{this.props.title}</ModalHeader>
                <ModalBody>
                    <Container style={managerModalContainer}>
                        <p style={modalBodyText}>
                            {i18n.t('screens:managerScreen.existingUserMsg')}
                        </p>
                        <p style={modalBodyText}>
                            {i18n.t('common:form.name')}: {this.state.name} <br />
                            {i18n.t('common:form.phone')}: {this.state.phone} <br />
                            {i18n.t('common:form.email')}: {this.state.email}
                        </p>
                        <p style={modalBodyText}>
                            {this.renderAssignMessage(this.props.role)}
                        </p>
                    </Container>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={this.assignManager}><MaterialIcon icon="check" color="#fff" size={20} />{i18n.t('common:buttons.assign')}</Button>
                    <Button outline color="primary" onClick={this.toggle}>{i18n.t('common:buttons.cancel')}</Button>
                </ModalFooter>
            </div>
        );
    }

    render() {
        this.copyStateFromProps();

        if (this.state.saveManagerStarted && this.state.id != -1) {
            this.assignManager();
            return null;
        }

        let form;
        if (!this.state.firstStepPassed) {
            form = this.renderFindManagerForm();
        } else if (this.state.id == -1) {
            form = this.renderCreateManagerForm();
        } else {
            form = this.renderAssignManagerForm();
        }
        return (
            <div>
                <Modal isOpen={this.props.isOpen} toggle={this.toggle}>
                    {form}
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        manager: state.manager
    };
};

export default connect(mapStateToProps, { loadManager, saveManager, clearManager, dispatchErrorMessage })(ManagerScreen);

let styles = {
    modalBodyText: {
        fontSize: '14px',
        textAlign: 'center'
    },
    warningColor: {
        color: '#FF990A',
        fontSize: '14px',
        textAlign: 'center'
    },
    spaceBetween: {
        paddingLeft: 4
    },
    managerModalContainer: {
        backgroundColor: '#f8f8f8',
        paddingTop: 10,
        paddingBottom: 10,
        border: '1px solid #E9ECEF'
    }
};


// WEBPACK FOOTER //
// ./src/components/users/ManagerScreen.js